import { Links } from './links';
import { Base } from './base';


export abstract class Followable extends Base {

  abstract _links: Links;

  public isFollowable(): boolean {

    return this._links.follow != null;
  }

  public isUnFollowable(): boolean {

    return this._links.unfollow != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/followable.ts